import {
  deleteRequest,
  getRequest,
  postRequest,
  putRequest,
} from "../utils/api";

/------ Maintenance APIs - START ------ /;

//Get all error codes
export const getErrorcodes = async () => {
  const response = await getRequest(`/Maintenance/errorcodelist`);
  return response;
};

// get technician list
export const getTechnicians = async (role) => {
  const response = await getRequest(`/Account/GetUsersByRole/?role=${role}`);
  return response;
};

//create work order

// export const createWorkOrder = async (workorderInfo) => {
//   const response = await postRequest(
//     `/Maintenance/AddWorkOrder`,
//     workorderInfo,
//   );
//   return response;
// };

export const createWorkOrder = async (workorderInfo) => {
  const formData = new FormData();

  Object.keys(workorderInfo).forEach((key) => {
    if (key !== "attachments") {
      formData.append(key, workorderInfo[key]);
    }
  });

  if (workorderInfo.attachments) {
    workorderInfo.attachments.forEach((file) => {
      formData.append("attachments", file);
    });
  }

  const response = await postRequest(`/Maintenance/AddWorkOrder`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return response;
};

// update work order

// export const updateExistingWorkOrder = async (workorderInfo) => {
//   const response = await putRequest(
//     `/Maintenance/UpdateWorkOrder`,
//     workorderInfo,
//   );
//   return response;
// };

export const updateExistingWorkOrder = async (workorderInfo) => {
  console.log(workorderInfo.attachments);
  const formData = new FormData();

  Object.keys(workorderInfo).forEach((key) => {
    if (key !== "attachments") {
      formData.append(key, workorderInfo[key]);
    }
  });

  if (workorderInfo.attachments) {
    workorderInfo.attachments.forEach((file) => {
      formData.append("attachments", file);
    });
  }

  const response = await putRequest(`/Maintenance/UpdateWorkOrder`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return response;
};

//Get work orders with attachments
export const getWorkOrderList = async () => {
  const response = await getRequest("/Maintenance/WorkOrders");
  return response;
};

//Get work order by id
export const getWorkOrderInfo = async (workorderId) => {
  const response = await getRequest(
    `/Maintenance/GetWorkOrder?WorkorderId=${workorderId}`,
  );
  return response;
};

//Delete work order
export const deleteWorkOrder = async (workOrderId) => {
  const response = await deleteRequest(
    `/Maintenance/DeleteWorkOrder?workOrderId=${workOrderId}`,
  );
  return response;
};

/------ Maintenance APIs - END ------ /;
